import { useState, useEffect, useRef } from 'react';
import api from '../../utils/api';
import { useToast } from '../../App';
import './AIRevenuePanel.scss';

const STORAGE_KEY = 'shopex_ai_revenue_history';

const Icons = {
    Bot: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="10" rx="2" /><circle cx="12" cy="5" r="2" />
            <path d="M12 7v4" /><line x1="8" y1="16" x2="8" y2="16" /><line x1="16" y1="16" x2="16" y2="16" />
        </svg>
    ),
    Sparkles: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3l1.88 5.76L20 10l-6.12 1.24L12 17l-1.88-5.76L4 10l6.12-1.24z" />
            <path d="M5 3l.88 2.68L8 6.5l-2.12.82L5 10l-.88-2.68L2 6.5l2.12-.82z" />
            <path d="M19 14l.88 2.68L22 17.5l-2.12.82L19 21l-.88-2.68L16 17.5l2.12-.82z" />
        </svg>
    ),
    User: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="4" /><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
        </svg>
    ),
    Send: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" />
        </svg>
    ),
    Trash: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" />
            <path d="M10 11v6M14 11v6M9 6V4h6v2" />
        </svg>
    ),
    X: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Refresh: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M23 4v6h-6" /><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" />
        </svg>
    ),
    BarChart: () => (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" />
            <line x1="6" y1="20" x2="6" y2="14" /><line x1="2" y1="20" x2="22" y2="20" />
        </svg>
    ),
    Zap: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
        </svg>
    ),
    Lock: () => (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" />
            <path d="M7 11V7a5 5 0 0110 0v4" />
        </svg>
    ),
    Crown: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 20h20M4 20L2 8l6 4 4-8 4 8 6-4-2 12" />
        </svg>
    ),
    TrendUp: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" />
        </svg>
    ),
    MessageCircle: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
        </svg>
    ),
    Target: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
        </svg>
    ),
    Brain: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9.5 2a2.5 2.5 0 015 0v.5a2.5 2.5 0 01-5 0V2z" />
            <path d="M4 8a4 4 0 014-4h8a4 4 0 014 4v8a4 4 0 01-4 4H8a4 4 0 01-4-4V8z" />
        </svg>
    ),
    Toggle: () => (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="1" y="6" width="22" height="12" rx="6" />
            <circle cx="16" cy="12" r="4" fill="currentColor" stroke="none" />
        </svg>
    ),
    ArrowRight: () => (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
        </svg>
    ),
};

const QUICK_QUESTIONS = [
    { label: 'Top products', text: 'What are my top performing products?' },
    { label: 'Boost revenue', text: 'How can I improve my revenue?' },
    { label: 'Peak days', text: 'What days have the most orders?' },
    { label: 'Low sales', text: 'Why might my sales be low?' },
];

const PRO_FEATURES = [
    { icon: <Icons.TrendUp />, title: 'Revenue Insights', desc: 'Instant AI analysis of your sales trends and growth patterns' },
    { icon: <Icons.MessageCircle />, title: 'Ask Anything', desc: 'Chat with AI about your store - get data-driven answers instantly' },
    { icon: <Icons.Target />, title: 'Actionable Tips', desc: 'Get specific recommendations to increase conversions and revenue' },
    { icon: <Icons.Brain />, title: 'Conversation Memory', desc: 'AI remembers your questions for contextual follow-up analysis' },
];

/**
 * Floating AI Revenue Analysis panel.
 *
 * Props:
 *   analyticsData    - current analytics data object
 *   dateRange        - current date range label
 *   aiRevenueEnabled - boolean: "Revenue Analysis with AI" toggle in WooCommerce → Settings → ShopEx
 *   isPro            - boolean/string: active PRO license ("1", 1, true)
 *
 * Three states:
 *   !isPro                       → PRO upsell screen
 *   isPro && !aiRevenueEnabled   → Settings guide (how to enable the toggle)
 *   isPro && aiRevenueEnabled    → Full AI chat panel
 */
const AIRevenuePanel = ({ analyticsData, dateRange, aiRevenueEnabled = false, isPro }) => {
    const { showError } = useToast();

    // Normalize isPro — handles "1", 1, true; treats "0"/"false"/null/undefined as false
    const hasProLicense = !!isPro && isPro !== '0' && isPro !== 'false';

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [history, setHistory] = useState([]);
    const [question, setQuestion] = useState('');
    const [hasAnalyzed, setHasAnalyzed] = useState(false);
    const [panelReady, setPanelReady] = useState(false);
    const chatEndRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved) {
                const parsed = JSON.parse(saved);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    setHistory(parsed);
                    setHasAnalyzed(true);
                }
            }
        } catch (_) { }
    }, []);

    useEffect(() => {
        if (history.length > 0) localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    }, [history]);

    useEffect(() => {
        if (open) chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [history, open, loading]);

    useEffect(() => {
        if (open) setTimeout(() => setPanelReady(true), 20);
        else setPanelReady(false);
    }, [open]);

    useEffect(() => {
        if (open && hasAnalyzed && hasProLicense && aiRevenueEnabled) setTimeout(() => inputRef.current?.focus(), 320);
    }, [open, hasAnalyzed, hasProLicense, aiRevenueEnabled]);

    const runAnalysis = async (userQuestion = '') => {
        if (!analyticsData) { showError('No analytics data available.'); return; }
        setLoading(true);
        try {
            const res = await api.analyzeRevenue(analyticsData, userQuestion, history);
            if (res.success) {
                setHistory(prev => [...prev, { question: res.question, answer: res.analysis }]);
                setHasAnalyzed(true);
                setQuestion('');
            } else {
                showError(res.message || 'AI analysis failed.');
            }
        } catch {
            showError('AI request failed. Check your AI settings.');
        } finally {
            setLoading(false);
        }
    };

    const handleAsk = () => { if (question.trim()) runAnalysis(question.trim()); };
    const handleKeyDown = (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleAsk(); } };
    const clearHistory = () => { setHistory([]); setHasAnalyzed(false); localStorage.removeItem(STORAGE_KEY); };

    const formatAnalysis = (text) => {
        if (!text) return null;
        return text.split('\n').map((line, i) => {
            if (line.startsWith('• ') || line.startsWith('- ')) {
                return <li key={i} dangerouslySetInnerHTML={{ __html: line.replace(/^[•\-]\s*/, '').replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />;
            }
            if (line.trim() === '') return <div key={i} className="arp-spacer" />;
            return <p key={i} dangerouslySetInnerHTML={{ __html: line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />;
        });
    };

    const goToUpgrade = () => { window.location.href = 'admin.php?page=shop-explorer-pricing'; };
    const goToSettings = () => { window.location.href = 'admin.php?page=shop-explorer#/settings'; };

    const headerSubtitle = hasProLicense && aiRevenueEnabled
        ? (dateRange ? `Analyzing: ${dateRange}` : 'Powered by AI · Always learning')
        : hasProLicense
            ? 'One step away — enable the toggle in Settings'
            : 'Upgrade to PRO to unlock AI revenue analysis';

    return (
        <>
            {/* FAB */}
            <button
                className={`ai-revenue-fab ${open ? 'active' : ''} ${!hasProLicense || !aiRevenueEnabled ? 'fab-locked' : ''}`}
                onClick={() => setOpen(v => !v)}
                aria-label="Open AI Revenue Analysis"
                aria-expanded={open}
            >
                <span className="fab-glow" aria-hidden="true" />
                <span className="fab-icon"><Icons.Bot /></span>
                <span className="fab-label">AI Analysis</span>
                {hasProLicense && aiRevenueEnabled && hasAnalyzed && !open && <span className="fab-dot" />}
            </button>

            {/* Panel */}
            <aside
                className={`ai-revenue-panel ${open ? 'open' : ''} ${panelReady ? 'ready' : ''}`}
                role="complementary"
                aria-label="AI Revenue Analysis"
            >
                <div className="arp-neural-bg" aria-hidden="true">
                    <div className="arp-orb arp-orb-1" /><div className="arp-orb arp-orb-2" />
                    <svg className="arp-mesh" viewBox="0 0 420 100" preserveAspectRatio="none">
                        <defs>
                            <pattern id="arp-grid" width="28" height="28" patternUnits="userSpaceOnUse">
                                <path d="M 28 0 L 0 0 0 28" fill="none" stroke="rgba(99,102,241,0.08)" strokeWidth="0.5" />
                            </pattern>
                        </defs>
                        <rect width="100%" height="100%" fill="url(#arp-grid)" />
                    </svg>
                </div>

                {/* Header */}
                <header className="arp-header">
                    <div className="arp-header-aurora" aria-hidden="true" />
                    <div className="arp-header-left">
                        <div className="arp-avatar">
                            {hasProLicense && aiRevenueEnabled ? <Icons.Bot /> : <Icons.Lock />}
                            {hasProLicense && aiRevenueEnabled && <span className="arp-avatar-pulse" />}
                        </div>
                        <div className="arp-header-text">
                            <h2 className="arp-title">Revenue Copilot</h2>
                            <p className="arp-subtitle">{headerSubtitle}</p>
                        </div>
                    </div>
                    <div className="arp-header-actions">
                        {hasProLicense && aiRevenueEnabled && history.length > 0 && (
                            <button className="arp-icon-btn" onClick={clearHistory} title="Clear conversation">
                                <Icons.Trash />
                            </button>
                        )}
                        <button className="arp-icon-btn arp-close-btn" onClick={() => setOpen(false)} title="Close">
                            <Icons.X />
                        </button>
                    </div>
                </header>

                {/* Body */}
                <div className="arp-body">

                    {/* ── STATE 1: No PRO license → Upsell ──────────────── */}
                    {!hasProLicense && (
                        <div className="arp-upsell">
                            <div className="arp-upsell-hero">
                                <div className="arp-upsell-lock-ring">
                                    <div className="arp-upsell-lock-icon"><Icons.Lock /></div>
                                </div>
                                <h3 className="arp-upsell-title">AI Revenue Analysis</h3>
                                <p className="arp-upsell-subtitle">
                                    Your personal AI business analyst - available 24/7, trained on your store data.
                                </p>
                            </div>

                            <div className="arp-upsell-features">
                                {PRO_FEATURES.map(({ icon, title, desc }) => (
                                    <div key={title} className="arp-upsell-feature">
                                        <div className="arp-upsell-feature-icon">{icon}</div>
                                        <div>
                                            <strong>{title}</strong>
                                            <p>{desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="arp-upsell-preview">
                                <div className="arp-preview-label">Preview</div>
                                <div className="arp-preview-bubble arp-preview-user">
                                    How can I increase my revenue this month?
                                </div>
                                <div className="arp-preview-bubble arp-preview-ai">
                                    <span className="arp-preview-ai-icon">✨</span>
                                    Based on your data, your top 3 opportunities are: <strong>upselling Product A</strong>, running a flash sale on slow-moving inventory, and targeting returning customers with a loyalty discount…
                                    <span className="arp-preview-blur" />
                                </div>
                            </div>

                            <div className="arp-upsell-cta">
                                <button className="arp-upgrade-btn" onClick={goToUpgrade}>
                                    <Icons.Crown />
                                    Upgrade to PRO - Unlock AI Analysis
                                    <span className="arp-btn-shimmer" />
                                </button>
                                <p className="arp-upsell-note">
                                    ✅ 14-day money-back guarantee &nbsp;·&nbsp; Cancel anytime
                                </p>
                                <button className="arp-settings-link" onClick={goToSettings}>
                                    Already have PRO? Enable in Shop Explorer Settings →
                                </button>
                            </div>
                        </div>
                    )}

                    {/* ── STATE 2: PRO active, toggle OFF → Settings guide ─ */}
                    {hasProLicense && !aiRevenueEnabled && (
                        <div className="arp-enable-guide">
                            <div className="arp-enable-hero">
                                <div className="arp-enable-badge">✓ PRO License Active</div>
                                <div className="arp-enable-icon-wrap">
                                    <Icons.Toggle />
                                </div>
                                <h3 className="arp-enable-title">Almost Ready!</h3>
                                <p className="arp-enable-subtitle">
                                    Enable the <strong>Revenue Analysis with AI</strong> toggle in your Shop Explorer Settings to activate this feature.
                                </p>
                            </div>

                            <div className="arp-enable-steps">
                                <div className="arp-enable-step">
                                    <span className="arp-step-num">1</span>
                                    <div className="arp-step-body">
                                        <strong>Go to Shop Explorer → Settings</strong>
                                        <span>In your Shop Explorer admin sidebar</span>
                                    </div>
                                </div>
                                <div className="arp-enable-step">
                                    <span className="arp-step-num">2</span>
                                    <div className="arp-step-body">
                                        <strong>Click the WooCommerce tab</strong>
                                        <span>Find AI Revenue Analysis in the settings below</span>
                                    </div>
                                </div>
                                <div className="arp-enable-step">
                                    <span className="arp-step-num">3</span>
                                    <div className="arp-step-body">
                                        <strong>Toggle on "Revenue Analysis with AI"</strong>
                                        <span>Flip the switch and click <em>Save changes</em> above placed</span>
                                    </div>
                                </div>
                                <div className="arp-enable-step">
                                    <span className="arp-step-num">4</span>
                                    <div className="arp-step-body">
                                        <strong>Click <em>🚀 View Analytics Dashboard</em></strong>
                                        <span>The AI panel will be ready to use instantly</span>
                                    </div>
                                </div>
                            </div>

                            <div className="arp-enable-cta">
                                <button className="arp-go-settings-btn" onClick={goToSettings}>
                                    Open WooCommerce Settings
                                    <Icons.ArrowRight />
                                    <span className="arp-btn-shimmer" />
                                </button>
                            </div>
                        </div>
                    )}

                    {/* ── STATE 3: PRO + enabled → Full AI chat ─────────── */}
                    {hasProLicense && aiRevenueEnabled && (
                        <>
                            {!hasAnalyzed && !loading && (
                                <div className="arp-welcome">
                                    <div className="arp-welcome-visual">
                                        <div className="arp-welcome-ring" />
                                        <div className="arp-welcome-icon-wrap"><Icons.BarChart /></div>
                                    </div>
                                    <h3 className="arp-welcome-title">Analyze Your Store</h3>
                                    <p className="arp-welcome-desc">
                                        Get AI-powered insights, trends, and actionable recommendations from your analytics data.
                                    </p>
                                    <div className="arp-chips">
                                        <p className="arp-chips-label">Quick questions</p>
                                        <div className="arp-chips-grid">
                                            {QUICK_QUESTIONS.map(({ label, text }) => (
                                                <button key={label} className="arp-chip" onClick={() => runAnalysis(text)} disabled={loading}>
                                                    <span className="arp-chip-zap"><Icons.Zap /></span>
                                                    {label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {!hasAnalyzed && loading && (
                                <div className="arp-loading-state">
                                    <div className="arp-loading-ring"><div className="arp-loading-inner" /></div>
                                    <p className="arp-loading-text">Analyzing your store data</p>
                                    <div className="arp-loading-dots"><span /><span /><span /></div>
                                </div>
                            )}

                            {history.length > 0 && (
                                <div className="arp-chat" role="log" aria-live="polite">
                                    {history.map((item, idx) => (
                                        <div key={idx} className="arp-chat-pair">
                                            <div className="arp-msg arp-msg-user">
                                                <div className="arp-msg-avatar arp-msg-avatar-user"><Icons.User /></div>
                                                <div className="arp-msg-bubble arp-bubble-user">{item.question}</div>
                                            </div>
                                            <div className="arp-msg arp-msg-ai">
                                                <div className="arp-msg-avatar arp-msg-avatar-ai"><Icons.Sparkles /></div>
                                                <div className="arp-msg-bubble arp-bubble-ai">
                                                    <div className="arp-analysis-body">{formatAnalysis(item.answer)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {loading && (
                                        <div className="arp-msg arp-msg-ai">
                                            <div className="arp-msg-avatar arp-msg-avatar-ai"><Icons.Sparkles /></div>
                                            <div className="arp-msg-bubble arp-bubble-ai arp-typing-bubble">
                                                <span className="arp-typing-dot" /><span className="arp-typing-dot" /><span className="arp-typing-dot" />
                                            </div>
                                        </div>
                                    )}
                                    <div ref={chatEndRef} />
                                </div>
                            )}
                        </>
                    )}
                </div>

                {/* Footer — only in full AI state */}
                {hasProLicense && aiRevenueEnabled && (
                    <footer className="arp-footer">
                        {!hasAnalyzed ? (
                            <button className={`arp-analyze-btn ${loading ? 'loading' : ''}`} onClick={() => runAnalysis()} disabled={loading}>
                                {loading ? <><span className="arp-btn-spinner" />Analyzing…</> : <><Icons.Sparkles />Analyze My Store Data</>}
                                <span className="arp-btn-shimmer" />
                            </button>
                        ) : (
                            <div className="arp-composer">
                                <div className={`arp-input-wrap ${loading ? 'disabled' : ''}`}>
                                    <textarea
                                        ref={inputRef}
                                        className="arp-textarea"
                                        rows={2}
                                        placeholder="Ask a follow-up question…"
                                        value={question}
                                        onChange={e => setQuestion(e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        disabled={loading}
                                    />
                                    <button className="arp-send-btn" onClick={handleAsk} disabled={loading || !question.trim()}>
                                        {loading ? <span className="arp-btn-spinner" /> : <Icons.Send />}
                                    </button>
                                </div>
                                <button className="arp-reanalyze-btn" onClick={() => runAnalysis()} disabled={loading}>
                                    <Icons.Refresh />Re-analyze with current data
                                </button>
                            </div>
                        )}
                    </footer>
                )}
            </aside>

            {open && <div className="ai-revenue-backdrop" onClick={() => setOpen(false)} aria-hidden="true" />}
        </>
    );
};

export default AIRevenuePanel;